export default __webpack_public_path__ + "static/media/avatar4.439eccbc.png";